import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from '@emotion/core';
import ChevronIcon from '@atlaskit/icon/glyph/chevron-down';
import { PrimaryButton } from '../PrimaryButton';
import { chevronIconCSS } from './styles';
export const PrimaryDropdownButton = /*#__PURE__*/forwardRef((props, ref) => {
  return jsx(PrimaryButton, _extends({
    iconAfter: jsx("span", {
      css: chevronIconCSS
    }, jsx(ChevronIcon, {
      label: ""
    })),
    ref: ref
  }, props));
});
export default PrimaryDropdownButton;